<template>
  <div id="app">
    <Navbar />
     
    <router-view>
      
    </router-view>
    <Footer />
   
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
 /* mounted() {
    window.addEventListener("beforeunload", this.handleUnload); // Ajouter l'écouteur d'événement
  },
 beforeUnmount() {  // Correct pour Vue 3
    window.removeEventListener("beforeunload", this.handleUnload);
},*/

  methods: {
    handleUnload() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  }

};
</script>

<style>
/* Styles globaux */
body {
  display:block;
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}




</style>
